export const createDenoiseWorkletNode = (context, options) => {
    return new AudioWorkletNode(context, 'denoise-processor', options);
};
//# sourceMappingURL=workletNodes.js.map